
// import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import DatePicker from 'vue2-datepicker'
import Matrix from './../../../../../shared/components/matrix'
import MasterService from './../../../../services/masterdata.service';
import ClientService from './../../../../../clientmanagement/services/clientmanagement.service';
import CONSTANT from './../../../../../shared/constants/constant'
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import XLSX from 'xlsx';
import Papa from "papaparse";

export default {
  name: 'services',
  components: {
    VueElementLoading,
    BasicSelect,
    DatePicker,
    Matrix,
    Treeselect
  },
  props: ['selectedEdit', 'clientServiceData', 'callingFromClientContract', 'contractidd'],
  data: function() {
    return {
      zones:[],
      disabledPTL: true,
      disabled: true,
      FTLPrePaid: '',
      FTLSurface: false,
      FTLForward: '',
      FTLReverse: '',
      FTLPay: '',
      FTLCredit: '',
      PTLPrePaid: '',
      PTLSurface: false,
      PTLAir: false,
      PTLForward: '',
      PTLReverse: '',
      PTLPay: '',
      PTLCredit: '',
      Air: '',
      Reverse: '',
      serviceLevelList: [],
      FTLBookingArray: [],
      FTLServiceArray: [],
      accordiandata: [],
      opened: [],
      isLoading: false,
      matrixLabel: {
        horizontal: "Pickup From",
        verticle: "Deliver To"
      },
      PTLSurfServiceArray: [],
      PTLAirServiceArray: [],
      PTLSurfBookingArray: [],
      PTLAirBookingArray: [],
      loadaccordian: true,
      isServiceSelected: true,
      ftlerror: [],
      ptlerror: [],
      showbutton: true,
      LoaderForPrefill: false,
      isMatrixSaveButtonHidden: true,
      matrixtabIndex: [],
      PTLmatrixtabIndex: [],
      allServiceLevelList:[],
      serviceLevelIdForFtlDownload:'',
      serviceLevelIdForPtlDownload:'',

      selectedFtl:[],
      selectedPtl:[],

      ftlObject:{
        "FTLSurfaceForward":{
          combination:{
            truckloadtype: "FTL",
            routemode: "Surface",
            servicetype: "Forward",
            bookingtype: [],
          },
          contractservicesid:null,
          serviceLevel:{},
          serviceLevelList:[],
          error:{
            serviceArea:null,
            serviceLevel:null
          },
          servicetypezonetozonecitytocity:null,
          uploadadditionalcities:0
        },
        "FTLSurfaceReverse":{
          combination:{
            truckloadtype: "FTL",
            routemode: "Surface",
            servicetype: "Reverse",
            bookingtype: [],
          },
          contractservicesid: null,
          serviceLevel:{},
          serviceLevelList:[],
          error:{
            serviceArea:null,
            serviceLevel:null
          },
          servicetypezonetozonecitytocity:null,
          uploadadditionalcities:0
        },
      },
      ptlObject:{
        "PTLSurfaceForward":{
          combination:{
            truckloadtype: "PTL",
            routemode: "Surface",
            servicetype: "Forward",
            bookingtype: [],
          },
          contractservicesid: null,
          serviceLevel:{},
          serviceLevelList:[],
          error:{
            serviceArea:null,
            serviceLevel:null
          },
          servicetypezonetozonecitytocity:null,
          uploadadditionalcities:0
        },
        "PTLSurfaceReverse":{
          combination:{
            truckloadtype: "PTL",
            routemode: "Surface",
            servicetype: "Reverse",
            bookingtype: [],
          },
          contractservicesid: null,
          serviceLevel:{},
          serviceLevelList:[],
          error:{
            serviceArea:null,
            serviceLevel:null
          },
          servicetypezonetozonecitytocity:null,
          uploadadditionalcities:0
        },
        "PTLAirForward":{
          combination:{
            truckloadtype: "PTL",
            routemode: "Air",
            servicetype: "Forward",
            bookingtype: [],
          },
          contractservicesid: null,
          serviceLevel:{},
          serviceLevelList:[],
          error:{
            serviceArea:null,
            serviceLevel:null
          },
          servicetypezonetozonecitytocity:null,
          uploadadditionalcities:0
        },
        "PTLAirReverse":{
          combination:{
            truckloadtype: "PTL",
            routemode: "Air",
            servicetype: "Reverse",
            bookingtype: [],
          },
          contractservicesid: null,
          serviceLevel:{},
          serviceLevelList:[],
          error:{
            serviceArea:null,
            serviceLevel:null
          },
          servicetypezonetozonecitytocity:null,
          uploadadditionalcities:0
        },
      }


    }
  },
  computed: {

  },
  async mounted() {
    if (this.selectedEdit.view == true) {
      this.showbutton = false;
    }
    await this.getServiceLevelDropdown()
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
    this.$nextTick(() => {
      if (this.selectedEdit.length == 0) {
        this.actionType = "ADD"
        if(this.contractidd){
          this.actionType = "EDIT";
          this.contractid = this.contractidd;
          this.getServicesDetails(this.contractid, 'ClientContract')
        }
      } else {
        this.actionType = "EDIT"
        if (this.selectedEdit.contracttemplateid) {
          this.contractid = this.selectedEdit.id
        } else {
          this.contractid = this.selectedEdit.id
        }
        if(this.contractidd){
          this.contractid = this.contractidd;
        }
        this.getServicesDetails(this.contractid, 'ClientContract')
      }
    })
    await this.getZonenamesdata()

  },
  methods: {
    // check() {
    //   if (this.actionType == "EDIT") {
    //     this.getServicesDetails(this.contractid)
    //   }
    // },
    async getServicesDetails(contractid, parent) {
      try {
        this.LoaderForPrefill = true
        let payload = {
          contractid: contractid
        }
        let result
        if (this.selectedEdit && this.selectedEdit.ComponentName == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
            payload.contractid = this.selectedEdit.id;
            result = await ClientService.getClientServicesDetailsforView(payload)
        } else {
          result = await MasterService.getServicesDetailsforView(payload)
        }
        var data = result.data.data
        var ftldata = []
        var ptldata = []
        for (var i = 0; i < data.contractmasterservices.length; i++) {
          let servicelevel =null
          var serviceleveldetail = []
          var contractservicesid ;
          let uploadadditionalcities=0
          let processedData = data.contractmasterservicelevel.filter(value =>{
            if (data.contractmasterservices[i].id == value.contractservicesid ) {
              return value
            }
          })
          let  servicetypezonetozonecitytocity=null
          for (var j = 0; j < data.contractmasterservicelevel.length; j++) {
            if(processedData.length==2)
            {
              if ((data.contractmasterservices[i].id == data.contractmasterservicelevel[j].contractservicesid || data.contractmasterservices[i].id == data.contractmasterservicelevel[j].clientcontractservicesid) && data.contractmasterservicelevel[j].servicetype==2 ) {
                servicelevel = data.contractmasterservicelevel[j].servicelevelid;
                contractservicesid = data.contractmasterservices[i].id;
              }
              uploadadditionalcities=1

            }
            else{
              if (data.contractmasterservices[i].id == data.contractmasterservicelevel[j].contractservicesid || data.contractmasterservices[i].id == data.contractmasterservicelevel[j].clientcontractservicesid ) {
                servicelevel = data.contractmasterservicelevel[j].servicelevelid;
                contractservicesid = data.contractmasterservices[i].id;
              }
            }
          }
          let serviceareatype
          if (data.contractmasterservices[i].serviceareatype) {
            serviceareatype = data.contractmasterservices[i].serviceareatype
          }
          if (data.contractmasterservices[i].truckloadtype == 'FTL') {
            ftldata.push({
              key: "FTL"+data.contractmasterservices[i].routemode+data.contractmasterservices[i].servicetype,
              routemode: data.contractmasterservices[i].routemode,
              servicetype: data.contractmasterservices[i].servicetype,
              bookingtype: data.contractmasterservices[i].bookingtype,
              servicelevelid: servicelevel,
              serviceleveldetail: serviceleveldetail,
              contractservicesid: contractservicesid,
              servicetypezonetozonecitytocity:serviceareatype,
              uploadadditionalcities:uploadadditionalcities
            })
          } else {
            ptldata.push({
              key: "PTL"+data.contractmasterservices[i].routemode+data.contractmasterservices[i].servicetype,
              routemode: data.contractmasterservices[i].routemode,
              servicetype: data.contractmasterservices[i].servicetype,
              bookingtype: data.contractmasterservices[i].bookingtype,
              servicelevelid: servicelevel,
              serviceleveldetail: serviceleveldetail,
              contractservicesid: contractservicesid,
              servicetypezonetozonecitytocity:serviceareatype,
              uploadadditionalcities:uploadadditionalcities
            })
          }
        }
        this.editdata = {
          contractid: this.contractid,
          contractname: data.contracttemplatename,
          contractdetail: {
            ftldata: ftldata,
            ptldata: ptldata
          }
        }
        this.$nextTick(() => {
          this.preFillContractServiceData(this.editdata)
        })
      } catch (err) {
        this.LoaderForPrefill = false;
        console.log(err);
      }
    },

    async preFillContractServiceData(editdata) {
      try {
        this.FTLServiceArray = []
        this.FTLBookingArray = []
        this.PTLSurfServiceArray = []
        this.PTLSurfBookingArray = []
        this.PTLAirServiceArray = []
        this.PTLAirBookingArray = []

        this.loadtab = 'PTL'
        for (let i = 0; i < editdata.contractdetail.ptldata.length; i++) {
          if (editdata.contractdetail.ptldata[i].routemode == "Surface") {
            this.PTLSurface = true
            if (this.PTLSurfServiceArray.indexOf(editdata.contractdetail.ptldata[i].servicetype) == -1) {
              this.PTLSurfServiceArray.push(editdata.contractdetail.ptldata[i].servicetype)
            }
            if (this.PTLSurfBookingArray.indexOf(editdata.contractdetail.ptldata[i].bookingtype) == -1) {
              this.PTLSurfBookingArray = editdata.contractdetail.ptldata[i].bookingtype;
            }
          } else if (editdata.contractdetail.ptldata[i].routemode == "Air") {
            this.PTLAir = true
            if (this.PTLAirServiceArray.indexOf(editdata.contractdetail.ptldata[i].servicetype) == -1) {
              this.PTLAirServiceArray.push(editdata.contractdetail.ptldata[i].servicetype)
            }
            if (this.PTLAirBookingArray.indexOf(editdata.contractdetail.ptldata[i].bookingtype) == -1) {
              this.PTLAirBookingArray = editdata.contractdetail.ptldata[i].bookingtype;
            }
          }
          this.ptlObject[editdata.contractdetail.ptldata[i].key].serviceLevel.id = editdata.contractdetail.ptldata[i].servicelevelid;
          if(editdata.contractdetail.ptldata[i].servicetypezonetozonecitytocity)
          {
            this.ptlObject[editdata.contractdetail.ptldata[i].key].servicetypezonetozonecitytocity = editdata.contractdetail.ptldata[i].servicetypezonetozonecitytocity;
          }
          if (editdata.contractdetail.ptldata[i].uploadadditionalcities == 1) {
            this.ptlObject[editdata.contractdetail.ptldata[i].key].uploadadditionalcities = 1
          }
          else {
            this.ptlObject[editdata.contractdetail.ptldata[i].key].uploadadditionalcities = 0
          }
          this.ptlObject[editdata.contractdetail.ptldata[i].key].contractservicesid = editdata.contractdetail.ptldata[i].contractservicesid;
          this.serviceLevelIdForPtlDownload = editdata.contractdetail.ptldata[i].contractservicesid
        }
        // await Promise.all(ptlserviceAreaPromiseArr)
        this.loadtab = 'FTL'
        for (var i = 0; i < editdata.contractdetail.ftldata.length; i++) {
          this.FTLSurface = true
          if (this.FTLServiceArray.indexOf(editdata.contractdetail.ftldata[i].servicetype) == -1) {
            this.FTLServiceArray.push(editdata.contractdetail.ftldata[i].servicetype)
          }
          if (this.FTLBookingArray.indexOf(editdata.contractdetail.ftldata[i].bookingtype) == -1) {
            this.FTLBookingArray = editdata.contractdetail.ftldata[i].bookingtype
          }
          this.ftlObject[editdata.contractdetail.ftldata[i].key].serviceLevel.id = editdata.contractdetail.ftldata[i].servicelevelid
          if(editdata.contractdetail.ftldata[i].servicetypezonetozonecitytocity)
          {
            this.ftlObject[editdata.contractdetail.ftldata[i].key].servicetypezonetozonecitytocity = editdata.contractdetail.ftldata[i].servicetypezonetozonecitytocity
          }
          if (editdata.contractdetail.ftldata[i].uploadadditionalcities == 1) {
            this.ftlObject[editdata.contractdetail.ftldata[i].key].uploadadditionalcities = 1
          }
          else {
            this.ftlObject[editdata.contractdetail.ftldata[i].key].uploadadditionalcities = 0
          }
          this.serviceLevelIdForFtlDownload = editdata.contractdetail.ftldata[i].contractservicesid
          this.ftlObject[editdata.contractdetail.ftldata[i].key].contractservicesid = editdata.contractdetail.ftldata[i].contractservicesid;

        }
        this.createAccordianDataForPTL()
        this.createAccordianDataForFTL()

        this.LoaderForPrefill = false

      } catch (err) {
        this.LoaderForPrefill = false;
        console.log(err);
      }
    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ['bg-primary', 'text-blue']
      } else {
        return ['bg-light', 'text-info']
      }
    },

    changeTab(tab) {
      this.opened = []
      this.loadtab = tab
      if (tab == 'FTL') {
        this.createAccordianDataForFTL()
      } else {
        this.createAccordianDataForPTL()
      }
    },

    chkFTLRouteMode() {
      if (this.FTLSurface == true) {
        this.disabled = false;
      } else {
        this.FTLServiceArray = []
        this.FTLBookingArray = []
        this.disabled = true;
        for (var k in this.ftlObject) {
            this.ftlObject[k].isSelected = false
        }
      }
      this.createAccordianDataForFTL()
    },
    chkPTLrouteModeSurface() {
      if (this.PTLSurface == true) {
        this.disabledPTL = false;
      } else {
        this.PTLSurfServiceArray = []
        this.PTLSurfBookingArray = []
        this.disabledPTL = true;
        for (var k in this.ptlObject) {
          if(this.ptlObject[k].combination.routemode == "Surface") {
            this.ptlObject[k].isSelected = false
          }
        }
      }
      this.createAccordianDataForPTL()
    },
    chkPTLrouteModeAir() {
      if (this.PTLAir == true) {
        this.disabledPTL = false;
      } else {
        this.disabledPTL = true;
        this.PTLAirServiceArray = []
        this.PTLAirBookingArray = []
        for (var k in this.ptlObject) {
          if(this.ptlObject[k].combination.routemode == "Air") {
            this.ptlObject[k].isSelected = false
          }
      }
      }
      this.createAccordianDataForPTL()
    },

    createAccordianDataForFTL() {
      this.accordiandata = []
      let tempBookingArr = []
      this.FTLBookingArray.forEach((item) => {
        let type = CONSTANT.BOOKING_MODE[item]
        tempBookingArr.push(type)
      });
      console.log("this.FTLBookingArray",this.FTLBookingArray);
      console.log("this.FTLSurface>>>>>>>>..",this.FTLSurface);
      if (this.FTLSurface) {
        for (var i = 0; i < this.FTLServiceArray.length; i++) {
            this.accordiandata.push({
              key:"FTLSurface"+this.FTLServiceArray[i],
              loadtype: "FTL",
              routemode: "Surface",
              servicetype: this.FTLServiceArray[i],
              bokkingtype: tempBookingArr
            })
        }

        for (var k in this.ftlObject) {
          let found = false;
          this.accordiandata.forEach((el)=>{
            if(el.key == k){
              found = true;
            }
          })
          if(found){
            console.log("found")
            this.isServiceSelected = true
            this.ftlObject[k].isSelected = true
            this.ftlObject[k].combination.bookingtype = this.FTLBookingArray
          } else {
            console.log("not found")
            this.ftlObject[k].isSelected = false
          }
        }
      } else {
        this.FTLServiceArray = []
        this.FTLBookingArray = []
      }
    },

    createAccordianDataForPTL() {
      this.accordiandata = []
      let tempSurfBookingArr = []
      this.PTLSurfBookingArray.forEach((item) => {
        let type = CONSTANT.BOOKING_MODE[item]
        tempSurfBookingArr.push(type)
      });
      if (this.PTLSurface) {
        for (var i = 0; i < this.PTLSurfServiceArray.length; i++) {
            this.accordiandata.push({
              key:"PTLSurface"+this.PTLSurfServiceArray[i],
              loadtype: "PTL",
              routemode: "Surface",
              servicetype: this.PTLSurfServiceArray[i],
              bokkingtype: tempSurfBookingArr
            })
        }
      } else {
        this.PTLSurfServiceArray = []
        this.PTLSurfBookingArray = []
      }
      let tempAirBookingArr = []
      this.PTLAirBookingArray.forEach((item) => {
        let type = CONSTANT.BOOKING_MODE[item]
        tempAirBookingArr.push(type)
      });
      if (this.PTLAir) {
        for (var i = 0; i < this.PTLAirServiceArray.length; i++) {
            this.accordiandata.push({
              key:"PTLAir"+this.PTLAirServiceArray[i],
              loadtype: "PTL",
              routemode: "Air",
              servicetype: this.PTLAirServiceArray[i],
              bokkingtype: tempAirBookingArr
            })
        }
      } else {
        this.PTLAirServiceArray = []
        this.PTLAirBookingArray = []
      }

      for (var k in this.ptlObject) {
        let found = false;
        this.accordiandata.forEach((el)=>{
          if(el.key == k){
            found = true;
          }
        })
        if(found){
          this.isServiceSelected = true
          this.ptlObject[k].isSelected = true
          if (k == "PTLSurfaceForward" || k == "PTLSurfaceReverse") {
            this.ptlObject[k].combination.bookingtype = this.PTLSurfBookingArray;
          }
          if (k == "PTLAirForward" || k == "PTLAirReverse") {
            this.ptlObject[k].combination.bookingtype = this.PTLAirBookingArray;
          }
        } else {
          this.ptlObject[k].isSelected = false
        }
      }
    },

    ShowServiceDetails(id) {
      const index = this.opened.indexOf(id);
      if (index > -1) {
        this.opened.splice(index, 1)
      } else {
        this.opened = [];
        this.opened.push(id)
      }
    },

    async selectServiceLevel(event, key) {
      if(this.ftlObject[key]){
        this.ftlObject[key].serviceLevel = event;
        this.ftlObject[key].error.serviceLevel = ""
        this.serviceLevelIdForFtlDownload = event.id
      }
      let payload = {
        servicelevelid: event.id
      }
      try {
          this.isLoading = true;
          let result = await MasterService.getServiceLevelDetail(payload);
          if (result.data.code == 200) {
          this.ftlObject[key].serviceleveldetail = result.data.data.rows.map((el)=>{
            return {
              "Origin Region":el.originregion,
               "Origin State":el.originstate,
               "Origin State Id":el.originstateid,
               "Origin City":el.origincity,
               "Origin City Id":el.origincityid,
               "Destination Region":el.destinationregion,
               "Destination State":el.destinationstate,
               "Destination State Id":el.destinationstateid,
               "Destination City":el.destinationcity,
               "Destination City Id":el.destinationcityid,
               "Route Mode" :el.travelmode,
               "E2E TAT":el.tat,
            }
          });
          this.isLoading = false;
        } else {
          this.isLoading = false;
          this.$alertify.error("Data Not Found")
        }

      } catch(err) {
        this.isLoading = false;
        console.log(err)
      }
    },
    async selectPTLServiceLevel(event, key) {
      if(this.ptlObject[key]){
        this.ptlObject[key].serviceLevel = event;
        this.ptlObject[key].error.serviceLevel = ""
        this.serviceLevelIdForPtlDownload = event.id
       }
       let payload = {
         servicelevelid: event.id
       }
       try {
           this.isLoading = true;
           let result = await MasterService.getServiceLevelDetail(payload);
           if (result.data.code == 200) {
            this.ptlObject[key].serviceleveldetail = result.data.data.rows.map((el)=>{
             return {
               "Origin Region":el.originregion,
                "Origin State":el.originstate,
                "Origin State Id":el.originstateid,
                "Origin City":el.origincity,
                "Origin City Id":el.origincityid,
                "Destination Region":el.destinationregion,
                "Destination State":el.destinationstate,
                "Destination State Id":el.destinationstateid,
                "Destination City":el.destinationcity,
                "Destination City Id":el.destinationcityid,
                "Route Mode" :el.travelmode,
                "E2E TAT":el.tat,
             }
           });
           this.isLoading = false;
         } else {
           this.isLoading = false;
           this.$alertify.error("Data Not Found")
         }

       } catch(err) {
         this.isLoading = false;
         console.log(err)
       }
    },

    async getServiceLevelDropdown() {
      try{
        let payload = {}
      let result = await MasterService.getServiceLevelDropdown(payload);
      if (result.data.code == 200) {
        for (var j = 0; j < result.data.data.count; j++) {
          let isdisabled=false;
          if(result.data.data.rows[j].status == 0){
             isdisabled=true;
          }
          this.allServiceLevelList.push({
            label: result.data.data.rows[j].servicelevelname,
            id: result.data.data.rows[j].id,
            isDisabled:isdisabled
          })
        }
      }
    }catch(err){
      console.log(err);
    }
  },

    groupBy(array, property) {
      var hash = {};
      for (var i = 0; i < array.length; i++) {
        if (!hash[array[i][property]]) hash[array[i][property]] = [];
        hash[array[i][property]].push(array[i]);
      }
      return hash;
    },
    createMatrixforZonetoZone(data) {
			// Define the list of zones and initialize an empty matrix
			const matrix = {};
			// Initialize the matrix with zeros
			const matrixArray = this.zones.map((origin) => {
			  const row = { '': origin };
			  this.zones.forEach((destination) => {
				const foundItem = data.find(item => item.origincity === origin && item.destinationcity === destination);
				row[destination] = foundItem ? foundItem.tat: null;
			  });
			  return row;
			});
			return matrixArray;
		  },
    async downloadFileForFtl(key,additionalcities) {
      this.LoaderForPrefill = true
      let payload = {
        contractid: this.contractid,
        contractservicesid : this.ftlObject[key].contractservicesid
      }
      if(this.ftlObject[key].servicetypezonetozonecitytocity==2 && additionalcities!=1)
      {
        payload.servicetype=this.ftlObject[key].servicetypezonetozonecitytocity
      }
      else{
        payload.servicetype=1
      }
      let result;
      let resultArr = [];
          if (this.selectedEdit && this.selectedEdit.ComponentName == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
          payload.contractid = this.selectedEdit.id;
          let countResult = await ClientService.getClientServicesDetailsCount(payload);
          let count = Number(countResult.data.data);
          let limit = 30000;
          let offset = 0;
          let tatlist = [];
          let loop =  Math.ceil(count / limit);
          for (let i = 0; i < loop; i++) {
            payload.limit = limit;
            payload.offset = offset;
            result = await ClientService.getClientServicesDetailsforDownload(payload);
            resultArr = resultArr.concat(result.data.data)  
            offset = offset + limit;
                }   
        } else {
          let countResult = await MasterService.getContractMasterServicesDetailsCount(payload);
          let count = Number(countResult.data.data);
          let limit = 30000;
          let offset = 0;
          let tatlist = [];
          let loop =  Math.ceil(count / limit);
          for (let i = 0; i < loop; i++) {
            payload.limit = limit;
            payload.offset = offset;
            result = await MasterService.getContractMasterServicesDetailsforDownload(payload);
            resultArr = resultArr.concat(result.data.data)  
            offset = offset + limit;
                }   
      }
        if (resultArr.length > 0) {
          this.LoaderForPrefill = false
          let downloadArr=[]
          this.servicetype=resultArr[0].servicetype
          if(this.servicetype==2)
          {
            downloadArr = this.createMatrixforZonetoZone(resultArr)
          }
          else{
            downloadArr = resultArr.map((el)=>{
              return {
                 "Origin Region":el.originregion,
                 "Origin State":el.originstate,
                 "Origin State Id":el.originstateid,
                 "Origin City":el.origincity,
                 "Origin City Id":el.origincityid,
                 "Destination Region":el.destinationregion,
                 "Destination State":el.destinationstate,
                 "Destination State Id":el.destinationstateid,
                 "Destination City":el.destinationcity,
                 "Destination City Id":el.destinationcityid,
                 "Route Mode" :el.travelmode,
                 "E2E TAT":el.tat,
              }
            });
          downloadArr.forEach(function(v){
            delete v['Origin City Id']
            delete v['Origin State Id']
            delete v['Destination City Id']
            delete v['Destination State Id']
          });
          }
        var blob = new Blob([Papa.unparse(downloadArr)], { type: 'text/csv;charset=utf-8;' });
        var link = document.createElement("a");
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", 'SalesTAT.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        //  this.getSelectedTemplateInfo(result.data.data.rows, key)
        } else {
          this.$alertify.error("Data Not Found")
        }
    },
    async downloadFileForPtl(key,additionalcities) {
      this.LoaderForPrefill = true
      let payload = {
        contractid: this.contractid,
        contractservicesid : this.ptlObject[key].contractservicesid
      }
      let result;
      let resultArr = [];
      if(this.ptlObject[key].servicetypezonetozonecitytocity==2 && additionalcities!=1)
      {
        payload.servicetype=this.ptlObject[key].servicetypezonetozonecitytocity
      }
      else{
        payload.servicetype=1
      }
      if (this.selectedEdit && this.selectedEdit.ComponentName == CONSTANT.CLIENT_CONTRACT_TEMPLATE) {
          payload.contractid = this.selectedEdit.id;
          let countResult = await ClientService.getClientServicesDetailsCount(payload);
          let count = Number(countResult.data.data);
          let limit = 30000;
          let offset = 0;
          let tatlist = [];
          let loop =  Math.ceil(count / limit);
          for (let i = 0; i < loop; i++) {
            payload.limit = limit;
            payload.offset = offset;
            result = await ClientService.getClientServicesDetailsforDownload(payload);
            resultArr = resultArr.concat(result.data.data)  
            offset = offset + limit;
            }   
        } else {
          let countResult = await MasterService.getContractMasterServicesDetailsCount(payload);
          let count = Number(countResult.data.data);
          let limit = 30000;
          let offset = 0;
          let tatlist = [];
          let loop =  Math.ceil(count / limit);
          for (let i = 0; i < loop; i++) {
            payload.limit = limit;
            payload.offset = offset;
            result = await MasterService.getContractMasterServicesDetailsforDownload(payload);
            resultArr = resultArr.concat(result.data.data)  
            offset = offset + limit;
                }   
      }
        if (resultArr.length > 0) {
          this.LoaderForPrefill = false
          let downloadArr=[]
          if (resultArr[0].servicetype==2) {
            downloadArr = this.createMatrixforZonetoZone(resultArr)
          }
          else{
            downloadArr = resultArr.map((el)=>{
              return {
                 "Origin Region":el.originregion,
                 "Origin State":el.originstate,
                 "Origin State Id":el.originstateid,
                 "Origin City":el.origincity,
                 "Origin City Id":el.origincityid,
                 "Destination Region":el.destinationregion,
                 "Destination State":el.destinationstate,
                 "Destination State Id":el.destinationstateid,
                 "Destination City":el.destinationcity,
                 "Destination City Id":el.destinationcityid,
                 "Route Mode" :el.travelmode,
                 "E2E TAT":el.tat,
              }
            });
            // let downloadArr = result.data.data
            downloadArr.forEach(function(v){
              delete v['Origin City Id']
              delete v['Origin State Id']
              delete v['Destination City Id']
              delete v['Destination State Id']
            });
          }
       
          var blob = new Blob([Papa.unparse(downloadArr)], { type: 'text/csv;charset=utf-8;' });
          var link = document.createElement("a");
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", 'SalesTAT.csv');
          link.style.visibility = 'hidden';
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        //this.getSelectedTemplateInfo(result.data.data.rows, key)
      } else {
        this.LoaderForPrefill = false
        this.$alertify.error("Data Not Found")
      }
  },

    async saveContractServices(buttonclick) {
        var contractmasterservices = []
        var ftlservices = []
        var ptlservices = []
        for (var key in this.ftlObject) {
          if(this.ftlObject[key].isSelected){
            let copyCombination = JSON.parse(JSON.stringify(this.ftlObject[key].combination))
            ftlservices.push(copyCombination);
            //copyCombination.serviceareaid = this.ftlObject[key].serviceArea.id
            copyCombination.status = 1;
            copyCombination.serviceleveldetail = [];
            for(var i=0;i<this.ftlObject[key].serviceleveldetail.length;i++){
              copyCombination.serviceleveldetail.push({
              servicelevelid: this.ftlObject[key].serviceLevel.id,
              originregion: this.ftlObject[key].serviceleveldetail[i]['Origin Region'],
              originstate: this.ftlObject[key].serviceleveldetail[i]['Origin State'],
              originstateid: this.ftlObject[key].serviceleveldetail[i]['Origin State Id'],
              origincity: this.ftlObject[key].serviceleveldetail[i]['Origin City'],
              origincityid: this.ftlObject[key].serviceleveldetail[i]['Origin City Id'],
              destinationregion: this.ftlObject[key].serviceleveldetail[i]['Destination Region'],
              destinationstate: this.ftlObject[key].serviceleveldetail[i]['Destination State'],
              destinationstateid: this.ftlObject[key].serviceleveldetail[i]['Destination State Id'],
              destinationcity: this.ftlObject[key].serviceleveldetail[i]['Destination City'],
              destinationcityid: this.ftlObject[key].serviceleveldetail[i]['Destination City Id'],
              travelmode: this.ftlObject[key].serviceleveldetail[i]['Route Mode'],
              tat: this.ftlObject[key].serviceleveldetail[i]['TAT'],
              status: 1
              })
            }
            contractmasterservices.push(copyCombination)
          }
        }
        for (let key in this.ptlObject) {
          if(this.ptlObject[key].isSelected){
            let copyCombination = JSON.parse(JSON.stringify(this.ptlObject[key].combination))
            ptlservices.push(copyCombination);
            //copyCombination.serviceareaid = this.ptlObject[key].serviceArea.id
            copyCombination.status = 1;
            copyCombination.serviceleveldetail = [];
            for(var i=0;i<this.ptlObject[key].serviceleveldetail.length;i++){
              copyCombination.serviceleveldetail.push({
              servicelevelid: this.ptlObject[key].serviceLevel.id,
              originregion: this.ptlObject[key].serviceleveldetail[i]['Origin Region'],
              originstate: this.ptlObject[key].serviceleveldetail[i]['Origin State'],
              originstateid: this.ptlObject[key].serviceleveldetail[i]['Origin State Id'],
              origincity: this.ptlObject[key].serviceleveldetail[i]['Origin City'],
              origincityid: this.ptlObject[key].serviceleveldetail[i]['Origin City Id'],
              destinationregion: this.ptlObject[key].serviceleveldetail[i]['Destination Region'],
              destinationstate: this.ptlObject[key].serviceleveldetail[i]['Destination State'],
              destinationstateid: this.ptlObject[key].serviceleveldetail[i]['Destination State Id'],
              destinationcity: this.ptlObject[key].serviceleveldetail[i]['Destination City'],
              destinationcityid: this.ptlObject[key].serviceleveldetail[i]['Destination City Id'],
              travelmode: this.ptlObject[key].serviceleveldetail[i]['Route Mode'],
              tat: this.ptlObject[key].serviceleveldetail[i]['TAT'],
              status: 1
              })
            }
            contractmasterservices.push(copyCombination)
          }
        }
        var input = {
          contractid: 0,
          ftlservices: ftlservices,
          ptlservices: ptlservices,
          createdby: this.userName,
          status: 1,
          contractmasterservices: contractmasterservices
        }
        if (this.actionType == "EDIT") {
          input.contractid = this.contractid
        }
        this.$emit("goBackToCreateContract", input, buttonclick)
    },

    getContractIDFromTemplate1(contractid, buttonclick) {
      this.contractid = contractid
    },
    async  getZonenamesdata()
    {
      let inputpayload={}
      let result = await MasterService.GetZoneNames(inputpayload);
      if(result.data.code==200)
      {
         this.zones = result.data.data
      }
      else{
        this.$alertify.success("Zones Data not found");
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/masterdata/views/contracttemplate/contracttemplateview/serviceview/serviceview.component.js